import { useEffect, useState } from "react";
import { Download, DownloadCloud } from "lucide-react";

import Drawer from "../../../../common/drawer/Drawer";
import Button from "../shared/Button";
import { loadMediaById } from "../../../../api/aws/media.api";


export default function DocumentPreviewDialog({

    open,

    document,

    onClose

}){

    const [

        media,

        setMedia

    ] = useState(null);

    const [

        loading,

        setLoading

    ] = useState(false);

    useEffect(()=>{

        if(

            !open ||

            !document?.media_id

        ){

            setMedia(null);

            return;

        }

        async function load(){

            try{

                setLoading(true);

                const response =

                    await loadMediaById(

                        document.media_id

                    );

                setMedia(

                    response.data

                );

            }

            finally{

                setLoading(false);

            }

        }

        load();

    },[

        open,

        document

    ]);

    return(

        <Drawer

            open={open}

            width={900}

            title={

                media?.original_name ||

                "Document"

            }

            subtitle={

                document?.doc_type

            }
            

            onClose={onClose}

        >

            {

                loading

                ?

                <div>

                    Loading...

                </div>

                :

                media

                ?

                <div className="crm-document-preview">
                 
            <Button

                icon={<DownloadCloud size={16}/>}

                onClick={()=>

                    window.open(

                        media.previewUrl,

                        "_blank"

                    )

                }

            >

                Download

            </Button>
                    {

                        media.isImage

                        ?

                        <img

                            src={media.previewUrl}

                            alt={media.original_name}

                        />

                        :

                        media.isPdf

                        ?

                        <iframe

                            src={media.previewUrl}

                            title={media.original_name}

                        />

                        :

                        <div className="crm-document-download">

                            <p>

                                Preview unavailable.

                            </p>

                            <Button

                                icon={<Download size={16}/>}

                                onClick={()=>

                                    window.open(

                                        media.previewUrl,

                                        "_blank"

                                    )

                                }

                            >

                                Download

                            </Button>

                        </div>

                    }

                </div>

                :

                <div>

                    Document not found.

                </div>

            }

<style>{`

.crm-document-preview{

    width:100%;

    height:calc(100vh - 170px);

}

.crm-document-preview img{

    width:100%;

    border-radius:12px;

}

.crm-document-preview iframe{

    width:100%;

    height:100%;

    border:none;

    border-radius:12px;

}

.crm-document-download{

    height:100%;

    display:flex;

    justify-content:center;

    align-items:center;

    flex-direction:column;

    gap:16px;

}

`}</style>

        </Drawer>

    );

}